export const reservationActionTypes = {
  CHANGE_STEP: 'CHANGE_STEP',
  CLEAR_RESERVATION_STEP: 'CLEAR_RESERVATION_STEP',

  //──── Booking ───────────────────────────────────────────────────────────────────────────

  CREATE_BOOKING_SUCCESS: 'CREATE_BOOKING_SUCCESS',
  CREATE_BOOKING_ERROR: 'CREATE_BOOKING_ERROR',

  //──── Prefers data ──────────────────────────────────────────────────────────────────────

  CLEAR_PREFER_DATA: 'CLEAR_PREFER_DATA',
  SET_PREFER_DATA: 'SET_PREFER_DATA',

  //──── Questions ─────────────────────────────────────────────────────────────────────────

  LOAD_QUESTION_LIST: 'LOAD_QUESTION_LIST',
  LOAD_QUESTION_BEHAVIOR_LIST: 'LOAD_QUESTION_BEHAVIOR_LIST',
  LOAD_QUESTIONS_ERROR: 'LOAD_QUESTIONS_ERROR',
  SET_QUESTIONS_RESULT: 'SET_QUESTIONS_RESULT',
  CLEAR_QUESTIONS_RESULT: 'CLEAR_QUESTIONS_RESULT',

  //──── Slots filters ─────────────────────────────────────────────────────────────────────

  ADD_CAMPUSES: 'ADD_CAMPUSES',
  CLEAR_GROUP_PRACTITIONERS: 'CLEAR_GROUP_PRACTITIONERS',
  CLEAR_SLOTS_FILTERS: 'CLEAR_SLOTS_FILTERS',
  SET_GROUP_PRACTITIONERS: 'SET_GROUP_PRACTITIONERS',
  SET_PRACTITIONERS: 'SET_PRACTITIONERS',
  SET_PR_WITH_DIGITAL_FLOW: 'SET_PR_WITH_DIGITAL_FLOW',
  SET_SLOTS_FILTERS: 'SET_SLOTS_FILTERS',
  UPDATE_SLOTS_FILTERS: 'UPDATE_SLOTS_FILTERS',

  //──── Slot actions ──────────────────────────────────────────────────────────────────────
  ADD_MORE_SLOTS: 'ADD_MORE_SLOTS',
  SELECT_SLOT: 'SELECT_SLOT',
  RESET_SLOTS: 'RESET_SLOTS',
  SUCCESS_LOAD_SLOTS: 'SUCCESS_LOAD_SLOTS',
  ERROR_LOAD_SLOTS: 'ERROR_LOAD_SLOTS',

  //──── Capthca token ─────────────────────────────────────────────────────────────────────
  SET_CAPTCHA_TOKEN: 'SET_CAPTCHA_TOKEN',
  CLEAN_CAPTCHA_TOKEN: 'CLEAN_CAPTCHA_TOKEN'
};
